import { AxiosResponse } from 'axios';
import { AuthenticatedClient ,CalendarParamsType , CalendarResponseType} from '_api';

export const getPlanningCalendarData = (params: CalendarParamsType): Promise<AxiosResponse<CalendarResponseType>> => {
  return AuthenticatedClient.post('/availability/', params);
};
